import CheckPlus from './check-plus.vue'

export default CheckPlus
